

import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Constants } from './Constants';

@Pipe({
  name: 'datemon',
  pure: true
})
export class DateMon extends DatePipe implements PipeTransform {

  override transform(value: any, args?: any): any {
    // debugger
    if (value != undefined) {
      var dateStr = value.replace('00:00:00.0', '');
      try {
        var result = super.transform(dateStr, Constants.DATE_MON)
      } catch (Exception) { }
      return result;
    }
  }
}